import React, { Component } from 'react';
import { Container, Row, Alert, Input, Button, ButtonGroup, UncontrolledPopover, PopoverBody } from 'reactstrap';
import QRCode from "react-qr-code";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQrcode, faCopy } from '@fortawesome/free-solid-svg-icons'
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { ReactComponent as Logo } from '../logo.svg';
import { MyLinks } from './MyLinks';


export class Home extends Component {
  state = {
    loading: false,
    error: '',
    result: '',
    input: '',
    emtpyerr: false,
    exiting: false,
    entering: false,
    turnstileSiteKey: '',
    turnstileAction: 'create',
    turnstileWidgetId: null,
    loginEnabled: false,
    loginUrl: '',
    logoutUrl: '',
    user: null,
    myLinksOpen: false,
  }

  componentDidMount() {
    fetch('/api/config')
      .then(r => r.ok ? r.json() : null)
      .then(cfg => {
        if (!cfg) return;
        this.setState({
          loginEnabled: !!cfg.loginEnabled,
          loginUrl: cfg.loginUrl || '',
          logoutUrl: cfg.logoutUrl || '',
          user: cfg.user || null,
        });
        if (!cfg.turnstileSiteKey) return;
        this.setState({
          turnstileSiteKey: cfg.turnstileSiteKey,
          turnstileAction: cfg.turnstileAction || 'create',
        });
        const renderWidget = () => {
          if (!window.turnstile || this.state.turnstileWidgetId !== null) return;
          const id = window.turnstile.render('#cf-turnstile', {
            sitekey: cfg.turnstileSiteKey,
            action: cfg.turnstileAction || 'create',
            appearance: 'interaction-only',
          });
          this.setState({ turnstileWidgetId: id });
        };
        if (!document.querySelector('script[data-turnstile="taobb"]')) {
          const s = document.createElement('script');
          s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
          s.async = true;
          s.defer = true;
          s.dataset.turnstile = 'taobb';
          s.onload = renderWidget;
          document.head.appendChild(s);
        } else {
          renderWidget();
        }
      })
      .catch(() => { });
  }

  getTurnstileToken() {
    const { turnstileSiteKey, turnstileWidgetId } = this.state;
    if (!turnstileSiteKey || !window.turnstile || turnstileWidgetId === null) {
      return Promise.resolve('');
    }
    if (this._turnstileInflight) {
      return this._turnstileInflight;
    }
    this._turnstileInflight = new Promise((resolve) => {
      try {
        window.turnstile.reset(turnstileWidgetId);
        window.turnstile.execute(turnstileWidgetId);
        const start = Date.now();
        const poll = setInterval(() => {
          const token = window.turnstile.getResponse(turnstileWidgetId);
          if (token) {
            clearInterval(poll);
            this._turnstileInflight = null;
            resolve(token);
          } else if (Date.now() - start > 15000) {
            clearInterval(poll);
            this._turnstileInflight = null;
            resolve('');
          }
        }, 200);
      } catch (e) {
        this._turnstileInflight = null;
        resolve('');
      }
    });
    return this._turnstileInflight;
  }

  render() {

    let buttons = []

    buttons.push(<Button color='primary' onClick={e => {
      if (this.state.loading) {
        return
      }

      if (this.state.result) {
        if (this.state.exiting) return;
        this.setState({ exiting: true })
        setTimeout(() => {
          this.setState({
            loading: false,
            input: '',
            result: '',
            error: '',
            exiting: false,
            entering: true,
          })
          setTimeout(() => this.setState({ entering: false }), 400)
        }, 350)
        return
      }

      if (!this.state.input) {
        this.setState({
          emtpyerr: true
        })
        setTimeout(() => {
          this.setState({
            emtpyerr: false
          })
        }, 200);
        return
      }

      this.setState({
        loading: true,
        error: '',
      })

      this.getTurnstileToken().then(turnstileToken => fetch("/api/create", {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ url: this.state.input, turnstileToken }),
      })
        .then(response => response.json())
        .then(data => {
          let location = window.location
          let prefix = location.protocol + "//" + location.hostname + (location.port ? ":" + location.port : "");

          if (data.error) {
            const limited = data.error === 'LIMIT EXCEEDED' && this.state.loginEnabled && !this.state.user;
            this.setState({
              error: limited ? data.error + ' · 登录后可获得更高额度' : data.error,
            })

          } else if (data.key) {
            this.setState({
              result: prefix + "/" + data.key,
              error: null,
            })
          }
        })
        .catch(() => {
          this.setState({
            error: "unknown error",
          })
        })
        .finally(() => {
          this.setState({
            loading: false,
          })
        }))

    }}>{this.state.loading
      ? <span className="btn-loading-dots"><span>·</span><span>·</span><span>·</span></span>
      : (this.state.result ? "再淘一个" : "tao.bb")}</Button>
    )

    if (this.state.result) {
      buttons.push(<CopyToClipboard key="copy" text={this.state.result}><Button className="btn-fade btn-fade-1" color='primary' ><FontAwesomeIcon icon={faCopy} /></Button></CopyToClipboard>)
      buttons.push(<Button key="qr" className="btn-fade btn-fade-2" color='primary' id="qrcode" ><FontAwesomeIcon icon={faQrcode} /></Button>)
    }

    return (
      <Container>
        {this.state.loginEnabled ?
          <div className="taobb-account" style={{ textAlign: 'right', marginTop: 12, fontSize: 14 }}>
            {this.state.user
              ? <span>
                <a href="#my-links" onClick={e => { e.preventDefault(); this.setState({ myLinksOpen: true }); }}>我的链接</a>
                {' · '}{this.state.user} · <a href={this.state.logoutUrl}>退出</a>
              </span>
              : <a href={this.state.loginUrl}>登录</a>}
          </div>
          : ''}
        {this.state.user ?
          <MyLinks isOpen={this.state.myLinksOpen} toggle={() => this.setState(s => ({ myLinksOpen: !s.myLinksOpen }))} />
          : ''}
        <Alert color="danger"
          className={"alert-anim " + (this.state.error ? "alert-shown" : "alert-hidden")}
          style={{ textAlign: 'center' }}
        >
          &nbsp;{this.state.error}&nbsp;
        </Alert >
        <Row style={{ marginTop: 80 }}>
            <svg className="taobb-logo" height='88' viewBox="0 0 370 100">
              <Logo />
            </svg>
        </Row>

        <Row className={(this.state.exiting ? 'row-exit ' : '') + (this.state.entering ? 'row-enter ' : '')} style={{ marginTop: 50 }}>
          <Input className='input-taobb'
            value={this.state.result ? this.state.result : this.state.input}
            readOnly={this.state.result ? true : false}
            autoFocus={true}
            autoComplete={"off"}
            placeholder="输入你想变短的网址如 http://www.taobao.com"
            style={
              this.state.result ? { width: '33%' } : {
                width: '100%',
                animation: this.state.emtpyerr ? 'shake .5s' : '',
                position: 'relative',
              }
            }
            onTransitionEnd={e => {
              // only after the shrink animation; focus/blur style transitions must not steal focus (e.g. from the My links search)
              if (this.state.result && e.propertyName === 'width' && !this.state.myLinksOpen) {
                e.target.select()
              }

            }}
            onChange={e => {
              if (!this.state.result) {
                this.setState({
                  'input': e.target.value
                })
              }
            }}

          />
        </Row>

        <Row className={this.state.exiting ? 'row-exit' : ''} style={{ marginTop: 50 }}>

          <ButtonGroup style={{ margin: 'auto', width: 250 }}>
            {buttons}
          </ButtonGroup>

        </Row>
        <div id="cf-turnstile" style={{ display: 'none' }}></div>
        {this.state.result ?
          <UncontrolledPopover
            hideArrow={false}
            placement="bottom"
            target="qrcode">
            <PopoverBody>
              <QRCode value={this.state.result} size={128} />
            </PopoverBody>
          </UncontrolledPopover>
          : ''}
      </Container>
    );
  }
}
